import { defineComponent as _defineComponent } from 'vue'
import type { FormModel } from "ant-design-vue"
import { message } from "ant-design-vue"
import type { Rule } from "ant-design-vue/es/form"
import { computed, reactive, ref } from "vue"

import useForm from "@/composables/useForm"
import { useServerFormErrors } from "@/composables/useServerFormErrors"
import i18n from "@/i18n"
import { createBrand } from "@/modules/offers/api/productModeration"
import type { CreateBrandFormValues } from "@/modules/offers/types/createOffer"
import type { ProductModerationBrand } from "@/modules/offers/types/offers"
import type { CreateBrandPayload } from "@/modules/offers/types/productModeration"

type Props = {
  visible?: boolean
}
type Emits = {
  (event: "create", payload: ProductModerationBrand): void
  (event: "close"): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBrandModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  emits: ["create", "close"],
  setup(__props: any, { emit }: { emit: ({
  (event: "create", payload: ProductModerationBrand): void
  (event: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean };




const formRef = ref<FormModel>()
const form = reactive<CreateBrandFormValues>({
  name: "",
  synonyms: ""
})

const { validateForm, isValidForm, formValidateRules, resetFields } = useForm(formRef)
const { getFieldErrorProps, setServerErrors, clearServerError, clearServerErrors } =
  useServerFormErrors()

const formRules = computed(() => ({
  name: [
    ...formValidateRules.value.textRequiredRule,
    { max: 150, message: i18n.t("validations.max", { count: 150 }) }
  ],
  synonyms: [{ validator: validateSynonyms }]
}))

const isFetching = ref<boolean>(false)

const validateSynonyms = (_rule: Rule, value: string, callback: Function) => {
  const synonymsArr = value.split(/[ ,\n]/gm).filter(Boolean)
  const uniqueSynonyms = new Set(synonymsArr)

  if (synonymsArr.length !== uniqueSynonyms.size) {
    return callback(new Error(i18n.t("findedDuplicates") as string))
  }

  if (synonymsArr.length > 50) {
    return callback(new Error(i18n.t("validations.max_values_count", { length: 50 }) as string))
  }

  if (synonymsArr.some((item) => item.length > 50)) {
    return callback(new Error(i18n.t("validations.max", { count: 50 }) as string))
  }

  return callback()
}
const onSubmit = async () => {
  if (isFetching.value) return

  clearServerErrors()
  isFetching.value = true
  try {
    await validateForm()

    if (!isValidForm.value) {
      return message.error(i18n.t("offers.offer_form_validate_error") as string)
    }

    const payload: CreateBrandPayload = {
      name_mlang: { uk: form.name },
      synonyms: form.synonyms.split(/[ ,\n]/gm).filter(Boolean)
    }
    const { data } = await createBrand({ payload })
    resetFields()
    clearServerErrors()
    emit("create", data)
  } catch (error) {
    setServerErrors(error, { name_mlang: ["name"], "name_mlang.uk": ["name"] })
  } finally {
    isFetching.value = false
  }
}
const onClose = () => {
  resetFields()
  clearServerErrors()
  emit("close")
}

return { __sfc: true,props, emit, formRef, form, validateForm, isValidForm, formValidateRules, resetFields, getFieldErrorProps, setServerErrors, clearServerError, clearServerErrors, formRules, isFetching, validateSynonyms, onSubmit, onClose }
}

})